import { render, staticRenderFns } from "./centerList.vue?vue&type=template&id=68190deb&scoped=true&"
import script from "./centerList.vue?vue&type=script&lang=js&"
export * from "./centerList.vue?vue&type=script&lang=js&"
import style0 from "./centerList.vue?vue&type=style&index=0&id=68190deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68190deb",
  null
  
)

export default component.exports